import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';

export function init() {
  window.Choices = Choices;

  // emit event when choices is ready
  window.dispatchEvent(
    new CustomEvent('choices-ready', {
      detail: {},
    }),
  )
}
